/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const Icon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M13.081,23.5 L4.5,23.5 C3.396,23.5 2.5,22.604 2.5,21.5 L2.5,2.5" />
      <path d="M21.5,0.5 L4.5,0.5 C3.396,0.5 2.5,1.395 2.5,2.5 C2.5,3.604 3.396,4.5 4.5,4.5 L21.5,4.5 L21.5,12.026" />
      <path d="M4.5,2.5 L20.5,2.5" />
      <path d="M21.11,17.256 C21.11,19.358 19.406,21.06 17.305,21.06 C15.203,21.06 13.499,19.357 13.499,17.256 C13.499,15.152 15.203,13.449 17.305,13.449 C19.406,13.449 21.11,15.152 21.11,17.256 Z" />
      <path d="M20,19.949 L23.5,23.449" />
    </g>
  </svg>
);

export default Icon;
